import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

import SRSTDetailCharts from './SRSTDetailCharts/SRSTDetailCharts';

import { useGetTrapDetail } from 'hooks/Traps/Trap/useGetTrapDetail';
import DeviceBreadCrump from 'components/DevicesDetail/DeviceDetailBreadCrump';
import TimeCard from 'components/DevicesDetail/MCT/TimeCard';
import TrapDataTableCard from 'components/DevicesDetail/MCT/TrapDataTableCard';
import TrapHistoryCard from 'components/DevicesDetail/MCT/TrapHistoryCard';
import TrapHourlyHistoryCard from 'components/DevicesDetail/MCT/TrapHourlyHistoryCard';
import { TrapTableType, TrapTableTypeLink } from 'components/TrapsTables/trapTables';

const SRSTDetail = () => {
  const { slug } = useParams();
  const { data, isLoading, isRefetching, refetch } = useGetTrapDetail(slug || '', 'srst');

  useEffect(() => {
    refetch();
  }, [slug, refetch]);

  return (
    <div className="page-content bg-light">
      <div className="container-fluid">
        <DeviceBreadCrump
          dropDownData={data?.select_trap_dropdow_data || null}
          objSlug={data?.object?.slug || ''}
          objName={data?.object?.name || ''}
          sq={data?.sequence_number || ''}
          sn={data?.serial_number || ''}
          deviceType={TrapTableType.SnapTrapRat}
          isLoading={isLoading}
          slug={slug || ''}
          deviceName="trap"
        />
        <div className="row">
          <div className="col-xl-3">
            <TimeCard work_time={data?.work_time || 0} />
            <TrapDataTableCard
              data={data || null}
              isLoading={isLoading}
              slug={slug || ''}
              isRefetching={isRefetching}
              type={TrapTableType.SnapTrapRat}
              deviceType={TrapTableTypeLink.SnapTrapRat}
            />
          </div>
          <div className="col-xl-9">
            <SRSTDetailCharts />
          </div>
        </div>
        <TrapHistoryCard slug={slug || ''} type="srst" />
        <TrapHourlyHistoryCard slug={slug || ''} type="srst" />
      </div>
    </div>
  );
};

export default SRSTDetail;
